import { lazy, Suspense, type CSSProperties } from "react";
import wordmark from "./assets/how-script-white.png";
import { SmokeCanvas } from "./SmokeCanvas";

const ShaderBackground = lazy(() => import("./ShaderBackground"));

/** WebGPU is what the shader layers need; everything else gets the Canvas 2D smoke. */
function hasWebGpu(): boolean {
  return typeof navigator !== "undefined" && "gpu" in navigator;
}

export interface SignInQuote {
  readonly text: string;
  readonly attribution: string;
}

export const DEFAULT_QUOTE: SignInQuote = {
  text: "Your congregation's data is yours alone.",
  attribution: "Every organization runs in its own isolated tenant.",
};

interface BrandPanelProps {
  readonly title: string;
  readonly quote: SignInQuote;
}

/** Left panel of the sign-in page: animated ground (WebGPU shader or canvas fallback), wordmark with the surface name, and a pull quote on large screens. */
export function BrandPanel({ title, quote }: BrandPanelProps) {
  return (
    <div className="how-signin-brand">
      <div className="how-signin-shader" aria-hidden="true">
        {hasWebGpu() ? (
          <Suspense fallback={null}>
            <ShaderBackground />
          </Suspense>
        ) : (
          <SmokeCanvas />
        )}
      </div>
      <div className="how-signin-wordmark how-signin-reveal">
        <img src={wordmark} alt="HoW" width="400" height="164" />
        <span>{title}</span>
      </div>
      <figure
        className="how-signin-quote how-signin-reveal"
        style={{ "--delay": "0.15s" } as CSSProperties}
      >
        <blockquote>{quote.text}</blockquote>
        <figcaption>{quote.attribution}</figcaption>
        <p>HoW, House of Worship by DCX Logic</p>
      </figure>
    </div>
  );
}
